import { create } from "zustand";
import { persist } from "zustand/middleware";
import { authenticatePlatform, isSessionExpired } from "@/lib/mockAuth";

const usePlatformSessionStore = create()(
  persist(
    (set, get) => ({
      operator: null,
      sessionExpiresAt: null,
      signIn: (email, password) => {
        const result = authenticatePlatform(email, password);
        if (!result.ok) {
          return result;
        }
        set({
          operator: result.operator,
          sessionExpiresAt: result.expiresAt,
        });
        return { ok: true };
      },
      signOut: () => set({ operator: null, sessionExpiresAt: null }),
      ensureSessionValid: () => {
        const { sessionExpiresAt, operator } = get();
        if (operator && isSessionExpired(sessionExpiresAt)) {
          set({ operator: null, sessionExpiresAt: null });
          return false;
        }
        return Boolean(operator);
      },
    }),
    { name: "gps-erp-next-platform-session" },
  ),
);

export { usePlatformSessionStore };
